const debounceTimers = {};

const debounce = (key, func, wait) => {
  console.log('setting debounced function for', key);
  if (debounceTimers[key]) {
    console.log('clearing open debounced function for', key);
    clearTimeout(debounceTimers[key]);
  }
  debounceTimers[key] = setTimeout(() => {
    delete debounceTimers[key];
    console.log('running debounced function for', key);
    func();
  }, wait);
};

export default debounce;
